import { render, staticRenderFns } from "./g-map-assessment.vue?vue&type=template&id=054a97e4&scoped=true"
import script from "./g-map-assessment.vue?vue&type=script&lang=js"
export * from "./g-map-assessment.vue?vue&type=script&lang=js"
import style0 from "./g-map-assessment.vue?vue&type=style&index=0&id=054a97e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a97e4",
  null
  
)

export default component.exports